import {uri} from '@/api/uri/base'
import Toast from '@/utils/toast'
import {
  getRequest,
  postJsonRequest,
  putJsonRequest,
  deleteRequest,
} from '@/utils/api'

/*
*   分页获取平台版本列表
* */
export function getPlatformVersionsInfo({projectNameEnglish}) {
  let params = {
    projectNameEnglish: projectNameEnglish
  }

  return new Promise((resolve, reject) => {
    getRequest(uri.version.get, params).then(resp => {
      resolve(resp.data)
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/base/platformVersions.js